module.exports = __webpack_public_path__ + "img/ExpensesBottomSheet.2e0100ec.png";